import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  withStyles,
  makeStyles,
  Grid,
  TextField,
  Card,
  CircularProgress,
  CardContent,
  IconButton,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle, 
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import Backlink from "../home-page/search/view/_back-link";
import { routePaths } from "../config/route-paths";
import { Button } from "@material-ui/core";
import { migrateService } from "./model/service.js";
import EFooterSection from "../e_home-page/e_footer-section/e_footer-section";
import ReCAPTCHA from "react-google-recaptcha";
import { config } from "../../enviroment";
import { DropzoneArea } from "material-ui-dropzone";
import { useSnackbar, SnackbarProvider } from "notistack";
import { saveAs } from "file-saver";
import { history } from "../../helpers";
import { Tooltip } from "@material-ui/core";
import HelpRoundedIcon from "@material-ui/icons/HelpRounded";
import { useMediaQuery } from "react-responsive";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import Link from "@material-ui/core/Link";
import { useLocation } from "react-router-dom";

const useStyle = makeStyles((theme) => ({
  blueText: {
    color: theme.palette.ePrimary?.base,
    fontWeight: "bold",
    "&:hover": {
      color: theme.palette.ePrimary?.hover,
    },
  },
  underlineText: {
    textDecoration: "underline",
  },
  margin: {
    marginLeft: "1rem",
    marginTop: "0.5rem",
    display: "flex",
    flexDirection: "column",
  },
  msg: {
    marginTop: "2rem",
  },
  btns: {
    marginTop: "1rem",
  },
  tableMargin: {
    marginTop: "1rem",
  },
  migrateBtn: {
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    color: "#ffffff",
    fontSize: "0.75rem",
    borderRadius: "29px",
    backgroundColor: "#15537c",
  },
  footer: {
    position: "fixed",
    bottom: 0,
    alignContent: "center",
    width: "100%",
    [theme.breakpoints.up("xl")]: {
      position: "fixed",
    },
    [theme.breakpoints.down("md")]: {
      position: "fixed",
      marginTop: "2%",
    },
  },
  mobileNumberError: {
    fontSize: "0.75em",
    color: theme.palette.eDanger?.dark + "!important",
    textAlign: "left",
  },
  centerCaptcha: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    position: "relative",
    zIndex: "2",
    [theme.breakpoints.up("xs")]: {
      scale: "0.85",
      left: "-27px",
    },
    [theme.breakpoints.down("md")]: {
      scale: "0.87",
      left: "-20px",
    },
    [theme.breakpoints.up("md")]: {
      scale: "0.85",
      left: "-23px",
    },
    [theme.breakpoints.up("lg")]: {
      scale: "0.85",
      left: "-23px",
    },
  },
  tooltip: {
    color: theme.palette.eMedium?.base,
    fontSize: "1.3rem",
    marginBottom: "0.4rem",
  },
  circularProgressColor: {
    color: theme.palette.eWhite.base,
  },
  // containerAign: {
  //   display: "flex",
  //   flexDirection: "row",
  //   [theme.breakpoints.down("md")]: {
  //     display: "flex",
  //     flexDirection: "column",
  //   },
  // },
  notesM: {
    marginTop: "0.5rem",
  },
  dialogContainerStyling: {
    "& .MuiDialog-paperWidthSm": {
      [theme.breakpoints.up("sm")]: {
        minWidth: "25rem !important",
      },
      [theme.breakpoints.down("sm")]: {
        minWidth: "20rem !important",
      },
    },
  },
  dialogTextPadding: {
    padding: "0rem 1.875rem 1.875rem",
    textAlign: "center",
  },
  dialoagActionPadding: {
    paddingTop: "0.938rem",
    paddingBottom: "0.938rem",
  },
  no: {
    color: theme.palette.ePrimary.base,
  },
  cardCont: {
    minHeight: "inherit",
  },
  mainContentHeight: {
    minHeight: "65vh",
  },
  yesBtn: {
    color: "white",
    cursor: "pointer",
  },
  alertIcon: {
    color: theme?.palette?.eTertiary?.base,
    width: "4rem",
    height: "auto",
    display: "block",
    margin: "1rem auto",
  },
  contentColor: {
    background: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    paddingLeft: "5%",
  },
  yes: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    padding: "3% 25%",
  },
  closeIcon: {
    color: theme.palette.eWhite.base,
  },
}));

export const CustomDropZone = withStyles((theme) => ({
  textContainer: {
    color: theme.palette.ePastelColor2?.base,
  },
  text: {
    margin: "7% 0% 3% 0%",
    color: theme.palette.ePrimary?.base,
    fontSize: "0.75rem",
  },
  icon: {
    color: theme.palette.ePrimary?.base,
  },
  root: {
    minHeight: "100%",

    width: "35%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  cardStyle: {
    height: "100vh",
  },
  contentBg: {
    background: theme?.palette?.eWhite?.base + " !important",
    paddingBottom: "1% !important",
  },
}))(DropzoneArea);

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.ePrimary?.base,
    boxShadow: theme.shadows[1],
    color: theme.palette.eWhite?.base,
    fontSize: "0.7rem",
    marginBottom: "0.4rem",
  },
}))(Tooltip);

export default function EUserMigration(props) {
  const fileInputRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const Excel = require("exceljs");
  let classes = useStyle();
  const { ready: labelReady } = useTranslation(
    "label-E_ALERTS_AND_NOTIFICATION"
  );
  const [file, setFile] = useState(null);
  const [fileData, setFileData] = useState([]);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [err, setErr] = useState("");
  const [showError, setShowErroe] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [emailError, setEmailError] = useState(false);
  const [emailRequire, setEmailRequire] = useState(false);
  const [noOfFiles, setNoOfFiles] = useState(0);
  const [key, setKey] = useState(0);
  const [dataAdded, setDataAdded] = useState(false);
  const [enUpload, setEnupload] = useState(false);
  const [uploadLoader, setUploadLoader] = useState(false);
  const [rOpen, setROpen] = useState(false);
  const [yLoad, setYload] = useState(false);
  const [mgLoad, setMgload] = useState(false);
  const [hideMig,setHidem] = useState(true)
  const search = props?.location?.state?.param;
  const openReryPop = useLocation().search.slice();
  const emailRegex = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_EMAIL_REGEX
  );
  const { t: labels, ready: labelreadyok } = useTranslation(
    "label-E_ONE_TIME_PAYMENTS"
  );
  const { t: content, ready: contentReady } = useTranslation(
    "content-E_SUMMARY_REVIEW"
  );
  const { t: loginLabels, ready: loginLabelReady } =
    useTranslation("label-E_AUTH_LOGIN");
  const summaryReviewLabel = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_SUMMARY_REVIEW
  );
  const { t: migrateLabels, ready: migrateLabelsReady } = useTranslation(
    "label-E_USER_MIGRATION"
  );

  let enableCaptcha = useSelector(
    (store) => store?.parametersWidgets.ParameterLookup?.ENABLE_CAPTCHA
  );
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const MAX_FILE_SIZE = parseInt(
    useSelector((state) => state?.parametersWidgets?.ParameterLookup?.MAX_SIZE)
  );

  const BATCH_SIZE = parseInt(
    useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_SMS_BATCH_COUNT)
  );
  const captchaRef = useRef();
  const upload = () => {
    setResult(null)
    let isArray = Array.isArray(fileData);
    let hasFIles = isArray
      ? fileData.length > 0
      : Object.keys(fileData).length > 0;
    if (hasFIles) {
      setUploadLoader(true);
      setErr("");
      setShowErroe(false);
      setEmailError(false);
      setEmailRequire(false);

      migrateService
        .upload(fileData, config.urls.AUTH_TOKEN,email)
        .then((res) => {
          setDataAdded(true);
          setHidem(false)
          enqueueSnackbar(
            "Data has been uploaded successfully added.",
            {
              variant: "success",
            },
            { autoHideDuration: 1000 }
          );
          setUploadLoader(false);
          setErr("");
          setShowErroe(false);
        })
        .catch((err) => {
          let msg='';
          setDataAdded(false);
          setUploadLoader(false);
          if (err.response.status == 400) {
            setShowErroe(true);
            msg="File with this has already been taken.";
            setErr(err?.response?.data?.message);
          } else if (err.response.status == 500) {
            setShowErroe(true);
            setErr(migrateLabels("Internal server error"));
            msg="Internal server error";
          } else if (err.response.status == 504) {
            setShowErroe(true);
            setErr(migrateLabels("Time out error"));
            msg="Time out error";
          } else {
            setShowErroe(true);
            setErr(err?.response?.data?.message);
            msg=err?.response?.data?.message
          }
          enqueueSnackbar(
            msg,
            {
              variant: "error",
            },
            { autoHideDuration: 1000 }
          );
        });
    } else {
      setUploadLoader(false);
      setEmailRequire(email.trim().length>0?false:true);
      if (!hasFIles) {
        setShowErroe(true);
        setErr(migrateLabels("E_MIGRATION_FILE_SELECT"));
      }
    }
  };
  const sendData = () => {

    setMgload(true)
    var jobId = Math.floor(Math.random() * 9000000000) + 1000000000;
      migrateService
        .migrate({name:jobId,take:100000})
        .then((res) => {
          setErr("");
          //setHidem(true)
          setMgload(false)
          setEnupload(true)
          setShowErroe(false);
          setLoading(false);
          setResult(res.data.UsersList);
        })
        .catch((err) => {
        //  setHidem(false)
          setMgload(false)
          setLoading(false);
          if (err.response.status == 400) {
            setShowErroe(true);
            setErr(migrateLabels("E_MIGRATION_TOKEN_ERROR"));
          } else if (err.response.status == 500) {
            setShowErroe(true);
            setErr(migrateLabels("Something went wrong"));
          } else if (err.response.status == 504) {
            setShowErroe(true);
            setErr(migrateLabels("Time out error"));
          } else {
            setShowErroe(true);
            setErr(migrateLabels("E_MIGRATION_FILE_ERROR"));
          }
        });

  };

  const download = async () => {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("user_migration_report");
    worksheet.properties.defaultColWidth = 30;
    worksheet.addRow([
      "UserName",
      "MobileNumber",
      "FirstName",
      "LastName",
      "Email",
      "status",
      "Remarks",
      "SMS sent",
      "Email sent",
      "Created",
      "LastUpdated"
    ]);
    let addRows = result.map((e) => {
      let row = [
        e.UserName,
        e.MobileNumber,
        e.FirstName,
        e.LastName,
        e.Email,
        e.Status,
        e.Remarks,
        e["SmsSent"],
        e["EmailSent"],
        e['Created'],
        e['LastUpdated']
      ];
      worksheet.addRow(row);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";

    const blob = new Blob([buffer], { type: fileType });

    saveAs(
      blob,
      "User_Migration_Report" + Date.now().toString() + fileExtension
    );
    worksheet.addRow([]);
  };

  let emailBlur = () => {
    if (email) {
      setEmailError(false);
      setEmailRequire(false);
      var emailRegExp = new RegExp(emailRegex);
      if (emailRegExp.test(email)) {
        setEmailError(false);
      } else {
        setEmailError(true);
      }
    } else {
      setEmailRequire(true);
    }
  };

  useEffect(() => {
    let isArray = Array.isArray(fileData);
    let hasFIles = isArray
      ? fileData.length > 0
      : Object.keys(fileData).length > 0;
    if (hasFIles) {
      setEnupload(true);
    } else {
      setEnupload(false);
    }
  }, [fileData]);

  useEffect(() => {
    if (search) {
      if (search.trim() == config.urls.AUTH_TOKEN) {
        history.push(routePaths.MIGRATE_USER);
      } else {
        history.push(routePaths.LOGIN);
      }
    }
  }, [search]);

  // useEffect(() => {
  //    if (openReryPop == config.urls.AUTH_TOKEN || openReryPop?.toString().includes("retry-sms-email")) {
  //     setROpen(true);
  //   }
  // }, [openReryPop]);

  useEffect(() => {
    if (disabled === false) {
      setDisabled(true);
    }
    setTimeout(() => {
      setCaptcha({ ...captcha, load: true });
    }, 500);
  }, []);

  const captchaAsyncScriptOnLoad = () => {
    setCaptcha({
      ...captcha,
      callback: "called!",
    });
  };

  const retry = async () => {
    if (rOpen) {
      setYload(true);
      await migrateService
        .newUserSms({ batchSize:BATCH_SIZE?BATCH_SIZE:1000  })
        .then((res) => {
          setYload(false);
        })
        .catch((err) => {
          setYload(false);
        });
      setROpen(false);
    } else {
      setYload(true);
      sendData()
        .then((res) => {
          setYload(false);
        })
        .catch((err) => {
          setYload(false);
        });
    }
  history.push(routePaths.MIGRATE_USER)
  };

  const cancelData = () => {
    setFile(null);
    setFileData([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFile = (event) => {
    event.preventDefault();
    setErr("");
    setShowErroe(false);
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  };
  useEffect(() => {
    if (
      fileData &&
      !emailError &&
      !emailRequire &&
      email.trim().length > 0 &&
      captcha.value != null
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [email, captcha, emailError, emailRequire,fileData]);

  const captchaHandleChange = (value) => {
    setCaptcha({
      ...captcha,
      value: value,
    });
    if (value !== null && dataAdded && email.trim().length > 0)
      setDisabled(false);
    if (value === null)
      setCaptcha({
        ...captcha,
        expired: true,
      });
  };

  const captchaHandleExpired = (value) => {
    captchaRef.reset();
  };

  const handleEmail = (event) => {
    event.preventDefault();
  };

  let handleChange = (e) => {
    const { name, value } = e.target;
    setEmailError(false);
    setEmailRequire(false);
    setEmail(value);
  };

  const handleFileChange = (files) => {
    let numOfFiles = files.length;
    setNoOfFiles(numOfFiles);
    let tempFileData = [];
    if (files.length > 0) {
      files.forEach((file) => {
        setFileData(file);
      });
    } else {
      setFileData([]);
    }
  };
  const handleClose = () => {
     setROpen(false);
     history.push(routePaths.MIGRATE_USER)
  };
  // const onDropHandler=(file)=>{
  //   file.forEach((item)=>{
  //     if(item?.size > Number(MAX_FILE_SIZE) * 1024 * 1024 ){
  //       let snackBarMsg = item?.name+" is of more than 5MB, upload a file less than or equal to 5MB."
  //       enqueueSnackbar(snackBarMsg,{
  //         variant: "error",
  //       });
  //     }
  //   })
  // }


  return (
    <>
      <SnackbarProvider>
        <Card
          className={classes.cardStyle}
          style={{ overflowY: browserName === "firefox" ? "auto" : "overlay" }}
        >
          <CardContent className={classes.contentBg} >
            <Grid className={classes.margin}>
              <Grid item xs={12}>
                <Backlink />
              </Grid>
              <Grid item xs={12} style={{ marginTop: "0.5rem" }}>
                {labelReady ? (
                  <Typography variant="h5" className={classes.blueText}>
                    {migrateLabels("E_MIGRATION_TITLE")}
                  </Typography>
                ) : (
                  <Skeleton />
                )}
              </Grid>
              <Grid item align="left">
                {
                  <Typography
                    variant="subtitle2"
                    className={classes.subtitleColor}
                    dangerouslySetInnerHTML={{
                      __html: migrateLabels("E_MIGRATION_DESC"),
                    }}
                  />
                }
              </Grid>
            </Grid>
            { <Grid className={classes.containerAign}>
              <Grid xs={6} className={classes.margin}>
                <Grid item>
                  <Grid item xs={12} className={classes.msg}>
                    <Typography variant="caption">
                      {migrateLabels("E_MIGRATION_UPLOAD")}
                      <deg style={{ color: "red" }}>*</deg>
                      <LightTooltip
                        placement="right-start"
                        enterTouchDelay={0}
                        title={
                          migrateLabelsReady
                            ? migrateLabels("E_FILE_TOOLTIP")
                            : ""
                        }
                      >
                        <HelpRoundedIcon
                          className={classes.tooltip}
                        ></HelpRoundedIcon>
                      </LightTooltip>
                    </Typography>
                    <Grid xs={12}>
                      <SnackbarProvider>
                        <CustomDropZone
                          // onDropRejected={onDropHandler}
                          className={classes.dropzoneComponent}
                          dropzoneText={
                            migrateLabelsReady
                              ? migrateLabels("E_MIGRATION_DRAG_UPLOAD")
                              : ""
                          }
                          acceptedFiles={[
                            "application/vnd.ms-excel",
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                          ]}
                          onChange={handleFileChange}
                          key={key}
                          filesLimit={1}
                          // getDropRejectMessage={(rejectedFile) =>
                          //   `Not accepted ${rejectedFile.name}`
                          // }
                          showFileNames
                          showAlerts={false}
                          value={fileData}
                          useChipsForPreview
                          previewChipProps={{
                            classes: { label: classes.previewChip },
                          }}
                          maxFileSize={50 * 1000000}
                          onAlert={(msg, variant) =>
                            variant !== "success" &&
                            enqueueSnackbar(
                              msg,
                              { variant: variant },
                              { autoHideDuration: 1000 }
                            )
                          }
                          onDrop={(e) => {
                            e.map((file) => {
                              if (
                                fileData.find((f) => f.fileName == file.name)
                              ) {
                                enqueueSnackbar(
                                  migrateLabelsReady
                                    ? migrateLabels(
                                        "E_MIGRATION_FILE_DUPLICATE"
                                      )
                                    : "",
                                  {
                                    variant: "error",
                                  },
                                  { autoHideDuration: 1000 }
                                );
                                e.preventDefault();
                                return;
                              }
                            });
                            if (fileData.length > 1) {
                              enqueueSnackbar(
                                migrateLabelsReady
                                  ? migrateLabels("E_MIGRATION_FILE_LIMIT")
                                  : "",
                                {
                                  variant: "error",
                                },
                                { autoHideDuration: 1000 }
                              );
                              e.preventDefault();
                              return;
                            }
                            e.forEach((item) =>
                              enqueueSnackbar(
                                item.name + " successfully added.",
                                {
                                  variant: "success",
                                },
                                { autoHideDuration: 1000 }
                              )
                            );
                          }}
                        />
                      </SnackbarProvider>
                      <br />
                      <Typography variant="caption">
                        {migrateLabelsReady
                          ? migrateLabels("E_MIGRATION_ADMIN_EMAIL")
                          : ""}
                        <deg style={{ color: "red" }}>*</deg>
                        <LightTooltip
                          placement="right-start"
                          enterTouchDelay={0}
                          title={
                            migrateLabelsReady
                              ? migrateLabels("E_MIGRATION_TOOLTIP")
                              : ""
                          }
                        >
                          <HelpRoundedIcon
                            className={classes.tooltip}
                          ></HelpRoundedIcon>
                        </LightTooltip>
                      </Typography>
                      <br />
                      <TextField
                        type="email"
                        placeholder={
                          migrateLabelsReady
                            ? migrateLabels("E_MIGRATION_EMAIL_PLACEHOLDER")
                            : ""
                        }
                        onBlur={emailBlur}
                        onChange={handleChange}
                        className={classes.inpStyle}
                      />
                      <Typography className={classes.mobileNumberError}>
                        {emailError ? (
                          loginLabelReady ? (
                            loginLabels("E_AUTH_LOGIN_EMAIL_ERROR")
                          ) : (
                            ""
                          )
                        ) : emailRequire ? (
                          loginLabelReady ? (
                            loginLabels("E_AUTH_LOGIN_EMAIL_REQUIRE")
                          ) : (
                            ""
                          )
                        ) : (
                          <span className={classes.errorSpace}>&nbsp;</span>
                        )}
                      </Typography>
                    </Grid>
                    <div className={classes.recaptcha}>
                      {captcha.load && enableCaptcha && (
                        <ReCAPTCHA
                          style={{ display: "inline-block" }}
                          theme="light"
                          ref={captchaRef}
                          sitekey={config.recaptcha.SITE_KEY}
                          onChange={captchaHandleChange}
                          asyncScriptOnLoad={captchaAsyncScriptOnLoad}
                          size="normal"
                          onExpired={captchaHandleExpired}
                          className={classes.centerCaptcha}
                        />
                      )}
                    </div>
                    <div>
                      {!loading && showError && (
                        <Typography
                          variant="body1"
                          style={{ color: "red", fontSize: "0.75rem" }}
                        >
                          {err}
                        </Typography>
                      )}
                    </div>
                    <div style={{ margin: "0.1rem",display:'flex'}}>
                     {<Button
                        data-sitekey={config.recaptcha.SITE_KEY}
                        variant="contained"
                        disabled={disabled}
                        className={classes.migrateBtn}
                        onClick={upload}
                      >
                        {migrateLabelsReady
                          ? migrateLabels("Upload")
                          : ""}
                        &nbsp;
                        {uploadLoader ? (
                          <CircularProgress
                            size={18}
                            className={classes.circularProgressColor}
                          />
                        ) : (
                          " "
                        )}
                      </Button>}
                     { <div style={{ marginLeft: "0.5rem"}}>
                      <Button
                        data-sitekey={config.recaptcha.SITE_KEY}
                        variant="contained"
                        className={classes.migrateBtn}
                        onClick={sendData}
                        disabled={hideMig}
                      >
                        {migrateLabelsReady ? migrateLabels("Migrate") : ""}
                        &nbsp;
                        {mgLoad ? (
                          <CircularProgress
                            size={18}
                            className={classes.circularProgressColor}
                          />
                        ) : (
                          " "
                        )}
                      </Button>
                    </div>}
                    </div>
                  </Grid>
                  <Grid item className={classes.btns}>
                    {result && (
                      <Typography variant="body2">
                        {migrateLabelsReady
                          ? migrateLabels("E_MIGRATION_COMPLETED_TEXT")
                          : ""}{" "}
                        <Button
                          className={classes.migrateBtn}
                          onClick={download}
                        >
                          {migrateLabelsReady
                            ? migrateLabels("E_MIGRATION_FILE_DOWNLOAD")
                            : ""}
                        </Button>
                      </Typography>
                    )}
                  </Grid>
                  <Grid item className={classes.btns}>
                  {hideMig==false && enUpload==true && (
                  <Typography variant="body2">
                        <Button
                          className={classes.migrateBtn}
                          onClick={()=>setROpen(true)}
                        >
                          Click here
                        </Button>
                        {migrateLabelsReady
                          ? " to send SMS or email to notify migrated users"
                          : ""}
                        
                      </Typography>
                  )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                xs={12}
                style={{ marginTop: "1rem", marginLeft: "1rem" }}
              >
                <Typography
                  variant="body2"
                  className={classes.notesM}
                  style={{ marginBottom: "1rem" }}
                >
                  {migrateLabelsReady ? "Instructions" : ""}
                </Typography>
                <Typography variant="body2" className={classes.notesM}>
                  {migrateLabelsReady
                    ? "1.Please upload a file first to start User Migration."
                    : ""}
                </Typography>
                <Typography variant="body2" className={classes.notesM}>
                  {migrateLabelsReady
                    ? migrateLabels("E_MIGRATION_NOTES_ONE")
                    : ""}
                </Typography>
                <Typography variant="body2" className={classes.notesM}>
                  {migrateLabelsReady
                    ? migrateLabels("E_MIGRATION_NOTES_TWO")
                    : ""}
                </Typography>
                <Typography variant="body2" className={classes.notesM}>
                  {migrateLabelsReady
                    ? "4. Once you click on Start Migration button, you can close the window. You will notified the reports via email"
                    : ""}
                </Typography>
              </Grid>
            </Grid>}
          </CardContent>
        </Card>
        <Dialog
          onClose={handleClose}
          open={rOpen}
          className={classes.dialogContainerStyling}
        >
          <Grid
            container
            alignItems="center"
            className={classes.contentColor}
            justify="space-between"
          >
            <Grid item xs={10}>
              <Typography variant="subtitle2">Send SMS and Email</Typography>
            </Grid>
            <Grid item xs={2} className={classes.rightIcon}>
              <IconButton aria-label="close" onClick={handleClose}>
                <Close className={classes.closeIcon} />
              </IconButton>
            </Grid>
          </Grid>
          <DialogContent dividers>
            <WarningRoundedIcon className={classes.alertIcon} />
            {contentReady ? (
              <Typography
                className={[classes.detailsSubLine, classes.dialogTextPadding]}
                dangerouslySetInnerHTML={{
                  __html:"Click <b>Yes</b> to send/resend SMS and email to users."
                }}
              ></Typography>
            ) : (
              <Skeleton variant="text"></Skeleton>
            )}
          </DialogContent>
          <DialogActions className={classes.dialoagActionPadding}>
            <Grid item xs={1} sm={1}>
              <Link
                component="button"
                onClick={() => {
                  handleClose();
                }}
                underline="hover"
                className={classes.no}
              >
                <Typography variant="button">
                  {summaryReviewLabel?.E_NO_LABEL}
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={3}>
              <Button
                onClick={() => {
                  retry();
                }}
                className={classes.yes}
              >
                {summaryReviewLabel?.E_YES_LABEL}&nbsp;
                {yLoad ? (
                  <CircularProgress
                    size={18}
                    className={classes.circularProgressColor}
                  />
                ) : (
                  " "
                )}
              </Button>
            </Grid>
          </DialogActions>
        </Dialog>

        <Grid className={classes.footer}>
          <EFooterSection />
        </Grid>
      </SnackbarProvider>
    </>
  );
}
